






import { Component, Prop, Vue, Mixins } from "vue-property-decorator";

// Mixins
import { WidgetMixin, TextMixin } from "./mixins";

@Component
export default class WInvitation extends Mixins(WidgetMixin, TextMixin) {
  @Prop({ type: String, required: true })
  value!: string;

  get isInvitation() {
    return !!this.getVariable(this.value);
  }
}
